import clsx from 'clsx';

type SpaceSliceProps = {
  primary: { size?: string; mobileSize?: string };
};

export function SpaceSlice({ primary }: SpaceSliceProps): JSX.Element {
  const { mobileSize, size } = primary || {};

  return (
    <>
      {mobileSize && (
        <div
          className={clsx('md:hidden', SPACING_TO_CLASSNAME_MAP[mobileSize])}
        />
      )}
      {size && (
        <div
          className={clsx(
            { 'hidden md:block': mobileSize },
            SPACING_TO_CLASSNAME_MAP[size],
          )}
        />
      )}
    </>
  );
}

const SPACING_TO_CLASSNAME_MAP: Record<string, string> = {
  '2xs': 'h-2xs',
  xs: 'h-xs',
  '2sm': 'h-2sm',
  sm: 'h-sm',
  md: 'h-md',
  lg: 'h-lg',
  xl: 'h-xl',
  '2xl': 'h-2xl',
  '3xl': 'h-3xl',
  '4xl': 'h-4xl',
  '5xl': 'h-5xl',
  '6xl': 'h-6xl',
  '7xl': 'h-7xl',
};
